import classNames from 'classnames';
import React from 'react';
import { Input, Select, SelectValue } from 'tdesign-react';

import { LabelType } from '@/const/promotion';
import { ImageRatio } from '@/const/richMedia';
import { RichMediaValue } from '@/interface/media';
import UploadPic from '@/material/form-upload/image';

import styles from './index.module.less';

export interface IProps {
  onChange: (key: any) => void;
  value: { text: string; icon: RichMediaValue, labelType: LabelType };
  disabled?: boolean;
}

const CustomLabel: React.FC<IProps> = (props) => {
  const {
    onChange,
    value = { text: '', icon: {}, labelType: LabelType.DEFAULT },
    disabled = false,
  } = props;

  const handleOnChange = (data?: RichMediaValue) => {
    onChange({ ...value, icon: data });
  };

  const handleInputChange = (data: string) => {
    onChange({ ...value, text: data });
  };

  const handleSelectChange = (data: SelectValue) => {
    if (data !== LabelType.DEFAULT) {
      onChange({ labelType: data });
      return;
    }
    onChange({ ...value, labelType: data });
  };

  const defaultDisabled = value?.labelType !== LabelType.DEFAULT ? true : disabled;

  return (
    <div
      className={classNames('custom-form-group', styles.group)}
      style={{ display: 'block', width: '100%' }}
    >
      <Select
        value={value?.labelType}
        onChange={handleSelectChange}
        style={{ width: '40%', marginBottom: 12 }}
        clearable
        placeholder='请选择类型'
        options={[
          { label: '自定义', value: LabelType.DEFAULT },
          { label: '热度数值', value: LabelType.HOT },
        ]}
      />
      <Input
        align="left"
        status="default"
        type="text"
        placeholder='角标文本'
        value={value?.text}
        onChange={handleInputChange}
        className={styles.input}
        disabled={defaultDisabled}
      />
      <UploadPic
        value={value?.icon}
        disabled={defaultDisabled}
        onChange={handleOnChange}
        width={150}
        height={150}
        wrapStyle={{
        }}
        imageStyle={{
          maxWidth: 'auto',
        }}
        limit={{ ratio: ImageRatio['1:1'] }}
        btnText="角标图片"
      />
    </div>
  );
};

export default CustomLabel;
